import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { GenericSeo } from "./views/shared/GenericSeo";

export const Faq = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: t("q1"),
      answer: (
        <>
          <p dangerouslySetInnerHTML={{ __html: t("r1") }}></p>
          <div className="mt-2">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/8qdNJhs_vg8?si=u8Yba2GYdC7_wR4h"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="rounded-lg shadow-md"
            ></iframe>
          </div>
        </>
      ),
    },
    { question: t("q2"), answer: t("r2") },
    {
      question: t("q3"), answer: (
        <>
          <p>{t("r3")}</p>
          <div className="mt-2">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/Bt0MJrWl5Z4?si=weRwtaf-VKUv7aak" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </>
      )
    },
    { question: t("q4"), answer: t("r4") },
    { question: t("q5"), answer: t("r5") },
    { question: t("q6"), answer: t("r6") },
    { question: t("q7"), answer: t("r7") },
  ];

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <GenericSeo routeName={'faq'} />
      <h1 className="text-2xl font-bold text-center text-blue-700 mb-6">{t("faq")}</h1>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => toggleFaq(index)}
              className="flex justify-between items-center w-full p-4 bg-blue-100 hover:bg-blue-200 transition duration-300"
            >
              <span className="text-lg font-semibold text-blue-800">{faq.question}</span>
              {openIndex === index ? <FaChevronUp className="text-blue-600" /> : <FaChevronDown className="text-blue-600" />}
            </button>
            {openIndex === index && (
              <div className="p-4 bg-gray-50 transition-opacity duration-300">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
